// extracted by mini-css-extract-plugin
export default {"container":"Yo-z","ratingLayout":"Zo-z","ratingLabel":"_o-z","nonInteractiveRatingLabel":"ap-z"};